import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import classnames from "classnames";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";

import { useParams } from "react-router-dom";
import useSWR from "swr";
import { publicAPIClient } from "../../utils/api_helper";
// Import Images
import Img1 from "../../assets/images/nft/img-01.jpg";

import Img5 from "../../assets/images/nft/img-05.jpg";

//SimpleBar
import SimpleBar from "simplebar-react";
import SettingsSkeleton from "../../Components/Skeletons/SettingsSkeleton";

const api = new publicAPIClient();

const transactionListFetcher = async (url) => {
  const { data } = await api.get(url);
  return data;
};

const CrowdFundPage = () => {
  document.title = "Item Details | Velzon - React Admin & Dashboard Template";
  const { id } = useParams();

  let { data, error, isValidating } = useSWR(
    `/crowdfund/donation/${id || ""}/crowdfund-detail/`,
    transactionListFetcher,
    {
      revalidateOnFocus: false, // revalidate when the page gains focus
      revalidateOnReconnect: false, // revalidate when the browser regains network connectivity
    }
  );

  let { data: donatinsList } = useSWR(`/crowdfund/donation/${id || ""}`, transactionListFetcher, {
    revalidateOnFocus: false, // revalidate when the page gains focus
    revalidateOnReconnect: false, // revalidate when the browser regains network connectivity
  });

  console.log(donatinsList, "CROWDDDD__FUND__DATAAA");

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span>You are good to go!</span>;
    } else {
      return (
        <>
          <h5 id="auction-time-1" className="mb-0">
            {days} : {hours} : {minutes} : {seconds}
          </h5>
        </>
      );
    }
  };

  return (
    <React.Fragment>
      <SettingsSkeleton>
        {data ? (
          <div className="page-content">
            <Container fluid>
              {/* <BreadCrumb title="Item Details" pageTitle="NFT Marketplace" /> */}
              <Card>
                <CardBody>
                  <Row className="g-4">
                    <Col lg={4}>
                      <div className="sticky-side-div">
                        <Card className="ribbon-box border shadow-none right">
                          <img src={data?.image} alt="" className="img-fluid rounded" />
                        </Card>
                        <div className="hstack gap-2">
                          <button className="btn btn-success w-100">
                            <Link to={`/cf-page/${data?.slug}/donate/`} className="text-white">
                              Lend a hand
                            </Link>
                          </button>
                        </div>
                      </div>
                    </Col>
                    <Col lg={8}>
                      <div>
                        {/* <UncontrolledDropdown className="float-end">
                      <DropdownToggle tag="a" className="btn btn-ghost-primary btn-icon" role="button">
                        <i className="ri-more-fill align-middle fs-16"></i>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-end">
                        <DropdownItem href="#" className="view-item-btn">
                          <i className="ri-eye-fill align-bottom me-2 text-muted"></i>View
                        </DropdownItem>
                        <DropdownItem href="#" className="edit-item-btn">
                          <i className="ri-pencil-fill align-bottom me-2 text-muted"></i> Edit
                        </DropdownItem>
                        <DropdownItem href="#" className="remove-item-btn">
                          <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown> */}

                        <span className="badge badge-soft-info mb-3 fs-12">
                          <i className="ri-eye-line me-1 align-bottom"></i>
                          {data?.donor_count} people have donated
                        </span>
                        <h4>{data?.title}</h4>
                        <div className="hstack gap-3 flex-wrap">
                          <div className="text-muted">
                            Creators :{" "}
                            <Link to="#" className="text-primary fw-medium">
                              {data?.user?.user?.first_name} {data?.user?.user?.last_name}
                            </Link>
                          </div>
                          <div className="vr"></div>

                          <div className="vr"></div>
                          <div className="text-muted">
                            Published : <span className="text-body fw-medium">{data?.created_at}</span>
                          </div>
                        </div>

                        <Row className="mt-4">
                          <Col lg={6} sm={6}>
                            <div className="p-2 border border-dashed rounded text-center">
                              <div>
                                <p className="text-muted fw-medium mb-1">Target :</p>
                                <h5 className="fs-17 text-success mb-0">
                                  <i className="mdi mdi-ethereum me-1"></i>GHS {data?.target_amount}
                                </h5>
                              </div>
                            </div>
                          </Col>

                          <Col lg={6} sm={6}>
                            <div className="p-2 border border-dashed rounded text-center">
                              <div>
                                <p className="text-muted fw-medium mb-1">Amount raised</p>
                                <h5 className="fs-17 mb-0">GHS {data?.current_amount} </h5>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-4 text-muted">
                          <p>{data?.description}</p>
                        </div>
                        <div className="product-content mt-5">
                          <Nav tabs className="nav-tabs-custom nav-success">
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: customActiveTab === "1",
                                })}
                                onClick={() => {
                                  toggleCustom("1");
                                }}
                              >
                                recent donors
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent
                            activeTab={customActiveTab}
                            className="border border-top-0 p-4"
                            id="nav-tabContent"
                          >
                            <TabPane id="nav-speci" tabId="1">
                              <div className="table-responsive">
                                <table className="table align-middle table-nowrap mb-0">
                                  <tbody>
                                    {donatinsList?.map((donation, i) => {
                                      return (
                                        <tr key={i}>
                                          <th scope="row">
                                            <div className="d-flex align-items-center">
                                              <img src={Img1} alt="" className="avatar-xs rounded object-cover" />
                                              {/* <Link to="/apps-nft-item-details" className="link-dark"> */}
                                              <span className="mb-0 ms-2">
                                                {donation?.first_name} {donation?.last_name}
                                              </span>
                                              {/* </Link> */}
                                            </div>
                                          </th>
                                          <td>GHS {donation?.amount} </td>

                                          {/* <td>29 min ago</td> */}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </div>
        ) : null}
      </SettingsSkeleton>
    </React.Fragment>
  );
};

export default CrowdFundPage;
